//-----------------------------------------------------------------------
// <copyright file="dialog-box.component.ts" company="LGT India">
//     Author: vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ApiService } from "../services/api.service";
import { AppComponent } from "../app.component";
import { UserDataService } from "./../services/user.service";

interface UserData {
  accountName: string;
  alreadyExist: string;
  disableRadioButton: boolean;
}
@Component({
  selector: "app-dialog-box",
  templateUrl: "./dialog-box.component.html",
  styleUrls: ["./dialog-box.component.css"], // Change here
  providers: [
    ApiService,
    AppComponent, // Add ApiService to the providers array
  ],
})
export class DialogBoxComponent implements OnInit {
  isError: boolean = false;
  searchIcon: string;
  closeIcon: string;
  accountName: string = "";
  userName: string = "";
  loginAccess: string = "";
  loginSA: string = "";
  durationInSeconds: number = 3;
  searchQuery: string = "";
  loading: boolean = false;
  showUserList: boolean = false;
  checkTrue: boolean = false;
  checkRatioTrue: boolean = false;
  users: string[] = [];
  selectedUser: { name: string } | null = null;
  showSpinner: boolean = true;
  makeAdmin: boolean = false;
  admin: boolean = false;
  loginAdmin: boolean = true;
  refreshToken: string = "";
  noData: boolean = false;
  size: number = 10;
  existEmail: string = "";
  userList: string = "";
  userData: UserData[] = [];
  searchFormControl: FormControl = new FormControl("");
  data: any;
  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    private app: AppComponent,
    private userDataService: UserDataService
  ) {
    this.searchIcon = "/assets/icons/searchIcon.svg";
    this.closeIcon = "/assets/icons/closeIcon.svg";
  }
  selectUser(user: any): void {
    this.userName = user;
    this.selectedUser = user;
  }

  cancelSelection(): void {
    this.selectedUser = null;
    this.makeAdmin = false;
    this.loginAdmin = true;
  }
  addUser(): void {
    this.selectedUser = null;
  }
  searchUsers() {
    // Check if search query length is at least 3 characters
    if (this.searchQuery.length >= 3) {
      this.users = this.users.filter((user) =>
        user.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      if (this.users.length > 0) {
        this.showUserList = true;
      } else {
      }
    } else {
      this.isError = true;
      this.openSnackBar("Please enter minimum 3 characters.");
      this.showUserList = false;
    }
  }

  onSearchChange(query: string): void {
    if (!query.trim()) {
      // Trigger searchUsers method
      this.fetchSearchUserData()
    }
    this.isError = true;
    this.searchQuery = query;
    if(this.searchQuery.length <= 2) {
      this.isError = true;
      this.openSnackBar("Please enter minimum 3 characters.");
      this.showUserList = false;
    }
    // Filter the users array based on the search query
    if (this.searchQuery.length >= 3) {
    this.users = this.userData
      .filter((user) =>
        user.accountName.toLowerCase().includes(query.toLowerCase())
      )
      .map((user) => user.accountName); // Extract only account names from filtered users
    }
    // Check if any user has alreadyExist === "Yes" and matches the search query
    const userExists = this.userData.some(
      (user) =>
        user.alreadyExist === "Yes" &&
        user.accountName.toLowerCase() === query.toLowerCase()
    );
    // Show error message if user exists
    if (userExists) {
      this.checkTrue = userExists;
      this.isError = true;
      this.openSnackBar("User Already Exists");
    } else if (this.users.length === 0) {
      // Show "Not found" message if no user matches the search query
      this.isError = true;
      this.openSnackBar("User Not Found");
    } else {
      this.isError = false; // Reset isError if user is found
    }
  }

  updateMakeAdmin(event: any) {
    this.makeAdmin = event.checked;
  }

  updateLoginAdmin(event: any) {
    this.loginAdmin = event.checked;
  }


  handleInputChange(): void {
    if (!this.searchQuery.trim()) {
    } else {
      this.searchUsers();
    }
  }

  closeDialog(event: MouseEvent): void {
    this.dialogRef.close();
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Backspace") {
      // Check if the searchQuery matches any user's name exactly
      this.fetchSearchUserData();
      this.showUserList = false;
      this.checkTrue = false;
    }
    this.checkTrue = false;
  }

  clearSearch(): void {
    this.searchQuery = "";
  }

  handleBackspace(event: KeyboardEvent): void {
    if (event.key === "Backspace" && !this.searchQuery.trim()) {
      this.clearSearch();
    }
  }
  ngOnInit() {
    this.handleInputChange();
    this.fetchSearchUserData();

    setTimeout(() => {
      this.showSpinner = false;
    }, 1000);

  }

  fetchSearchUserData(): void {
    this.loading = true; // Set loading to true when fetching data
    const accessToken: any = sessionStorage.getItem("accessToken");
    this.apiService.showUserList(accessToken, this.isError).subscribe({
      next: (response: any) => {
        const accountNames = response.data.map((item: any) => item.accountName);
        this.users = accountNames;
        const alreadyExitEmail = response.data.map(
          (item: any) => item.alreadyExist
        );
        this.userData = response.data.map((item: any) => ({
          accountName: item.accountName,
          alreadyExist: item.alreadyExist,
          disableRadioButton: item.alreadyExist
        }));
        this.existEmail = alreadyExitEmail;

        this.noData = this.users.length === 0;
        this.loading = false; // Set loading to false after data is fetched
      },
      error: (error) => {
        console.error("Post Request Failed:", error);
        this.loading = false;
        if (error.status === 403) {
          this.isError = true;
          this.openSnackBar("User logged out");

          setTimeout(() => {
            this.app.logout();
          }, 2000);
        }
        if (error.status === 401) {
          this.isError = true;
          const refreshToken: any = sessionStorage.getItem("refreshToken");
          // Call refreshToken method
          this.apiService.refreshToken(refreshToken).subscribe({
            next: (res: any) => {
              this.refreshToken = res.data.accessToken;
              sessionStorage.removeItem("accessToken");
              sessionStorage.removeItem("refreshToken");
              if (res.data.accessToken && res.data.refreshToken) {
                sessionStorage.setItem("accessToken", res.data.accessToken);
                sessionStorage.setItem("refreshToken", res.data.refreshToken);
              }
              this.fetchSearchUserData();
            },
            error: (refreshError) => {
              console.error("Error refreshing token:", refreshError);
              this.isError = true;
              this.openSnackBar("User logged out");
              this.onCancelClick();
              setTimeout(() => {
                this.app.logout();
              }, 2000);
            },
          });
        }
      },
    });
  }
  onCancelClick(): void {
    this.dialogRef.close();
    this.makeAdmin = false;
    this.loginAdmin = true;
  }


checkIfDisable(user: string): boolean {
  // Check if there's an active search query
  if (this.searchQuery) {
    // Find the index of the user in the userData array based on the search query
    const userIndex = this.userData.findIndex(u => u.accountName.toLowerCase() === user.toLowerCase());

    // If the user index is found and the corresponding existEmail value is 'Yes', disable the radio button
    if (userIndex !== -1 && this.existEmail[userIndex] === 'Yes') {
      return true;
    } else {
      return false;
    }
  } else {
    // Use the provided existEmail array to determine whether to disable the radio button
    const userIndex = this.userData.findIndex(u => u.accountName === user);

    // If the corresponding existEmail value is 'Yes', disable the radio button
    if (userIndex !== -1 && this.existEmail[userIndex] === 'Yes') {
      return true;
    } else {
      return false;
    }
  }
}


  
  
  
  

  sendPostRequest() {
    const makeAdminValue = this.makeAdmin === true ? "Yes" : "No";
    const loginAdminValue = this.loginAdmin === true ? "Yes" : "No";
    const accessToken: any = sessionStorage.getItem("accessToken");
    this.apiService
      .postData(
        this.userName,
        makeAdminValue,
        loginAdminValue,
        accessToken,
        this.isError
      )
      .subscribe({
        next: (response) => {
          this.isError = false;
          this.openSnackBar("User Added successfully");
          this.userDataService.triggerFetchUserData();
        },
        error: (error) => {
          console.error(error);
          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");
            this.onCancelClick();
            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken: any = sessionStorage.getItem("refreshToken");
            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res: any) => {
                this.refreshToken = res.data.accessToken;
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                this.sendPostRequest();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
                this.onCancelClick();
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },
            });
          }
        },
        complete: () => {
          this.dialogRef.close();
        },
      });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, "x", {
      duration: this.isError ? 3000 : 5000,
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: this.isError
        ? ["mat-mdc-snack-bar-container", "red"]
        : ["mat-mdc-snack-bar-container", "green"],
    });
  }
}
